<template>
  <div class="languages">
    <ul>
      <li v-for="language of locales.available">
        {{language}}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const {locales} = useConfig()
</script>

<style scoped lang="scss">
.languages {
  display: block;
  font-size: 16px;

  ul {
    li {
      display: inline-block;
      padding: 0 6px;
      cursor: pointer;
      text-transform: uppercase;
      transition: opacity 0.15s ease-in-out;
      opacity: 0.2;

      &:hover {
        transition: opacity 0.15s ease-in-out;
        opacity: 0.5;
      }
    }
  }
}
</style>